'use client';

import { useSetAtom } from 'jotai';
import Button, { ButtonVariants } from '../Button';
import contactModalTriggerButton from '../../store/contactForm';
import styles from './RevealingPoints.module.scss';

export interface IRevealingPointsButtonProps {
  actionButtonVariant: ButtonVariants;
  contactFormType?: 'section' | 'modal';
  text: string;
}

const RevealingPointsButton = ({ actionButtonVariant, text, contactFormType }: IRevealingPointsButtonProps) => {
  const setContactsModalTrigger = useSetAtom(contactModalTriggerButton);

  const buttonActionAttr = contactFormType === 'modal'
    ? { onClick: () => setContactsModalTrigger('revealing points section') }
    : { link: '#contact-form' };

  return (
    <Button
      variant={actionButtonVariant}
      {...buttonActionAttr}
      className={styles.button}
      icon={(
        <svg className={styles.itemIcon}>
          <use
            xlinkHref='/media/icon-nest.svg#iconNest'
            href='/media/icon-nest.svg#iconNest'
          />
        </svg>
          )}
    >
      {text}
    </Button>
  );
};

export default RevealingPointsButton;
